import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from '../config/api';

import OfferModal from "../components/OfferModal";
import "./Offers.css";

const HomeIconSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g clipPath="url(#offers_clip_home)">
      <path
        d="M11.0833 13.9997H2.91667C1.30842 13.9997 0 12.6913 0 11.083V5.67203C0 4.70078 0.480667 3.79661 1.28567 3.25411L5.36842 0.498445C6.3595 -0.170055 7.6405 -0.170055 8.63158 0.498445L12.7149 3.25411C13.5193 3.79661 14 4.7002 14 5.67203V11.083C14 12.6913 12.6916 13.9997 11.0833 13.9997ZM7 1.16461C6.65933 1.16461 6.31867 1.26495 6.02117 1.4662L1.93783 4.22128C1.45483 4.54678 1.16667 5.0887 1.16667 5.67145V11.0824C1.16667 12.0473 1.95183 12.8324 2.91667 12.8324H11.0833C12.0482 12.8324 12.8333 12.0473 12.8333 11.0824V5.67203C12.8333 5.08928 12.5452 4.54678 12.0627 4.22186L7.97883 1.4662C7.68133 1.26495 7.34067 1.16461 7 1.16461Z"
        fill="#6E727B"
      />
    </g>
    <defs>
      <clipPath id="offers_clip_home">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 12L10 8L6 4"
      stroke="#6E727B"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Offers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    loadOffers();
  }, []);

  const loadOffers = async () => {
    try {
      const data = await api.getOffers();
      setOffers(data);
    } catch (e) {
      setOffers([]);
    } finally {
      setLoading(false);
    }
  };

  const openOffer = (offer) => {
    setSelectedOffer(offer);
    setShowModal(true);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  return (
    <div className="offers-page">

      {/* Header banner / breadcrumb */}
      <div className="inner-banner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumps">
                <li>
                  <Link to="/">
                    <HomeIconSvg />
                    Home
                  </Link>
                </li>
                <li>
                  <ChevronRight />
                </li>
                <li className="breadcrumps-current">Offers</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="container">

        {loading ? (
          <div className="offers-grid">
            {[1,2,3,4,5,6].map(i => (
              <div key={i} className="offer-skeleton">
                <div className="sk-offer-img"></div>
                <div className="sk-offer-body">
                  <div className="sk-offer-title"></div>
                  <div className="sk-offer-sub"></div>
                  <div className="sk-offer-btn"></div>
                </div>
              </div>
            ))}
          </div>
        ) : offers.length === 0 ? (
          <div className="offers-empty">
            <i className="fas fa-tag"></i>
            <h4>No Offers Available</h4>
            <p>Check back soon for exciting deals!</p>
          </div>
        ) : (
          <div className="offers-grid">
            {offers.map((offer) => (
              <div className="offer-card" key={offer.id}>
                <div className="offer-image-wrapper">
                  <img
                    src={offer.listing_image}
                    alt={offer.title}
                    className="offer-image"
                  />
                </div>
                <div className="offer-content">
  <h5>{offer.title}</h5>
  <div className="offer-footer">
    {offer.end_date && (
      <p className="offer-validity">
        Valid till: <span>{formatDate(offer.end_date)}</span>
      </p>
    )}
    <button className="offer-btn" onClick={() => openOffer(offer)}>
      View
    </button>
  </div>
</div>
              </div>
            ))}
          </div>
        )}

      </div>

      <OfferModal
        show={showModal}
        offer={selectedOffer}
        onHide={() => setShowModal(false)}
      />
    </div>
  );
};

export default Offers;